// UX-043 — what a person who is not part of any aggregator sees on the aggregator
// screens (/agg/*, /team). It only explains the situation and offers a way out;
// the membership check (`hasAggregatorAccess`) stays where it was, in
// AggregatorContext, and nothing here grants or widens access.

import AdminGate from '../organisation/AdminGate'

export default function NotAnAggregatorGate({ area }: { area: string }) {
  return (
    <AdminGate
      area={area}
      title="You're not part of an aggregator"
      description={
        <>
          {area.charAt(0).toUpperCase()}{area.slice(1)} is for people on an aggregator&apos;s team.
          Your own work is not affected: an aggregator only sees what you choose to share with it.
        </>
      }
    />
  )
}
